/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_CronInputs */

const en_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const ar_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجدول`)
};

const bn_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const de_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const es_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const fr_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const pt_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const zh_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计划任务`)
};

const tr_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const ru_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Крон`)
};

const pl_svchip_cron = /** @type {(inputs: Svchip_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kron`)
};

/**
* | output |
* | --- |
* | "Cron" |
*
* @param {Svchip_CronInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_cron = /** @type {((inputs?: Svchip_CronInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_CronInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_cron(inputs)
	if (locale === "bn") return bn_svchip_cron(inputs)
	if (locale === "de") return de_svchip_cron(inputs)
	if (locale === "es") return es_svchip_cron(inputs)
	if (locale === "fr") return fr_svchip_cron(inputs)
	if (locale === "pt") return pt_svchip_cron(inputs)
	if (locale === "zh") return zh_svchip_cron(inputs)
	if (locale === "tr") return tr_svchip_cron(inputs)
	if (locale === "ru") return ru_svchip_cron(inputs)
	if (locale === "pl") return pl_svchip_cron(inputs)
	return en_svchip_cron(inputs)
});